import graphql__42083c1a4f1987c7f402 from "./__generated__/EditMailingListCriterionDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import Section from "../form/Section";
import {useRelayEnvironment} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";
import MailingListCriterionFields from "./MailingListCriterionFields";

type Condition = {
    attributeName: string;
    operator: string;
    value: string | null;
};

type Props = {
    mailingListId: string;
    currentCriterion: {conditions: ReadonlyArray<Condition>} | null;
    handleCloseDialog: () => void;
}

const EditMailingListCriterionDialog: React.FC<Props> = ({mailingListId, currentCriterion, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const currentCondition = currentCriterion?.conditions?.[0];

    const handleSubmission = (values) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__42083c1a4f1987c7f402,
                variables: {
                    input: {
                        id: mailingListId,
                        criterion: {
                            conditions: [{
                                attributeName: values.attributeName,
                                operator: values.operator,
                                value: values.operator === 'EQUALS' ? values.value : null,
                            }],
                        },
                    }
                },
                onCompleted: () => {
                    handleCloseDialog();
                },
                onError: () => {
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToUpdateMailingListCriterion'})
            }
        )
    }

    const initialValues = {
        type: 'DYNAMIC',
        attributeName: currentCondition?.attributeName || '',
        operator: currentCondition?.operator || 'EQUALS',
        value: currentCondition?.value || '',
    }

    const validationSchema = yup.object().shape({
        attributeName: yup.string().required(intl.formatMessage({id: 'validation.field.required'})),
        operator: yup.string().oneOf(['EQUALS', 'EXISTS']).required(),
        value: yup.string().when('operator', {
            is: 'EQUALS',
            then: yup.string().required(intl.formatMessage({id: 'validation.field.required'})),
        }),
    });

    return (
        <FormDialog handleCloseDialog={handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    headline={intl.formatMessage({id: 'dialog.EditMailingListCriterionDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.save'})}>
            <Section>
                <MailingListCriterionFields/>
            </Section>
        </FormDialog>
    )
}

export default EditMailingListCriterionDialog;
